import 'modules/input-suggestion';
import {getLCP, getCLS, onINP} from 'web-vitals';

const addToGlobal = (...propTuple) => {
  propTuple.forEach(([name, value]) => {
    window[name] = value;
  });
};

addToGlobal(
  ['getLCP', getLCP],
  ['getCLS', getCLS],
  ['onINP', onINP],
);

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
window.logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  $.ajax({
    type: 'POST',
    data: $.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
}

$(document).ready(() => {
  $('.js-input-suggestions').inputSuggestion();

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get(window.rcProps.clearWishlistUrlParam) === 'true') {
    $.modal({
      url: window.rcProps.oldWishlistRemovedModalHref,
      type: 'notification',
      triggerOpen: true,
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/global.js